import * as i0 from '@angular/core';
import * as i1 from './accordion.module';
import * as i2 from '@angular/common';
import * as i3 from '../icon/icon.component';
import * as i4 from './accordion.component';
import * as i5 from './accordion-item.component';
import * as i6 from './accordion-item-header.component';
import * as i7 from './accordion-item-body.component';
import * as i8 from '../icon/icon.module';
export const ElAccordionModuleNgFactory:i0.NgModuleFactory<i1.ElAccordionModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ElIconComponent = (<any>(null as any));
var _decl0_12:i4.ElAccordionComponent = (<any>(null as any));
var _decl0_13:i5.ElAccordionItemComponent = (<any>(null as any));
var _decl0_14:i6.ElAccordionItemHeaderComponent = (<any>(null as any));
var _decl0_15:i7.ElAccordionItemBodyComponent = (<any>(null as any));
var _decl0_16:i2.AsyncPipe = (<any>(null as any));
var _decl0_17:i2.UpperCasePipe = (<any>(null as any));
var _decl0_18:i2.LowerCasePipe = (<any>(null as any));
var _decl0_19:i2.JsonPipe = (<any>(null as any));
var _decl0_20:i2.SlicePipe = (<any>(null as any));
var _decl0_21:i2.DecimalPipe = (<any>(null as any));
var _decl0_22:i2.PercentPipe = (<any>(null as any));
var _decl0_23:i2.TitleCasePipe = (<any>(null as any));
var _decl0_24:i2.CurrencyPipe = (<any>(null as any));
var _decl0_25:i2.DatePipe = (<any>(null as any));
var _decl0_26:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_27:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_28:i2.KeyValuePipe = (<any>(null as any));
var _decl0_29:i2.CommonModule = (<any>(null as any));
var _decl0_30:i8.ElIconModule = (<any>(null as any));
var _decl0_31:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_32:i0.ElementRef<any> = (<any>(null as any));
function _View_ElAccordionComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_ElAccordionComponent_1_0():void {
  var _any:any = (null as any);
}
function _View_ElAccordionItemComponent_Host_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_13.collapsed;
  currVal_0;
  const currVal_1:any = _decl0_13.expanded;
  currVal_1;
  const currVal_2:any = _decl0_13.disabled;
  currVal_2;
}
function _View_ElAccordionItemComponent_2_0():void {
  var _any:any = (null as any);
}
function _View_ElAccordionItemHeaderComponent_Host_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_14.isCollapsed;
  currVal_0;
  const currVal_1:any = _decl0_14.expanded;
  currVal_1;
  const currVal_2:any = _decl0_14.expanded;
  currVal_2;
  const currVal_3:any = _decl0_14.tabbable;
  currVal_3;
  const currVal_4:any = _decl0_14.disabled;
  currVal_4;
  const pd_5:any = ((<any>_decl0_14.toggle()) !== false);
}
function _View_ElAccordionItemHeaderComponent_3_1():void {
  if (!_decl0_14.disabled) {
    var _any:any = (null as any);
    const currVal_0:any = 'chevron-down-outline';
    currVal_0;
    const currVal_1:any = 'endlessjs-essentials';
    currVal_1;
    const currVal_2:any = _decl0_11.html;
    currVal_2;
    const currVal_3:any = _decl0_11.primary;
    currVal_3;
    const currVal_4:any = _decl0_11.info;
    currVal_4;
    const currVal_5:any = _decl0_11.success;
    currVal_5;
    const currVal_6:any = _decl0_11.warning;
    currVal_6;
    const currVal_7:any = _decl0_11.danger;
    currVal_7;
    const currVal_8:any = _decl0_14.state;
    currVal_8;
  }
}
function _View_ElAccordionItemHeaderComponent_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = !_decl0_14.disabled;
  currVal_0;
}
function _View_ElAccordionItemBodyComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_ElAccordionItemBodyComponent_4_0():void {
  var _any:any = (null as any);
  const currVal_0:any = {value:_decl0_15.state};
  currVal_0;
}
